import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The FichaProvidersType component.
 */
const FichaProvidersType = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-TiposDeProveedores.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>
          Selecciona el tipo de distribución que deseas para los datos, puede ser monto transado o número de órdenes de
          compra.
        </Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Leyenda correspondiente a los colores asignado a cada tipo de proveedor.</Item>
        <Item>
          Esfera que representa la cantidad de monto transado o número de órdenes de compra con cada tipo de proveedor.
        </Item>
        <Item>Indicadores por cada tipo de proveedor según su tamaño de empresa.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default FichaProvidersType
